import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import io from 'socket.io-client';
import { AuthService } from './auth/auth.service';
import { EnvService} from './env.service'


export const environment = {
  production: false,
  SOCKET_ENDPOINT: 'http://localhost:3021'
};

@Injectable({
  providedIn: 'root'
})
export class SocketioService {

  private socket: any

  constructor(private authService: AuthService, private env: EnvService) {
  }

  // setupSocketConnection(fromHubId, toHubId, custId) {

  //   this.socket.emit('initiateReplacement', fromHubId + "|" + toHubId + "|" + custId);

  //   this.socket.on('my broadcast', (data: string) => {
  //     console.log(data);
  //   });

  //   this.socket.on('stat', (data: string) => {
  //     console.log(data);
  //   });
  // }

  createReplacementRoom(info: string) {
    this.socket = io(this.env.apiUrl, {
      path: '/api/socket.io',
      query: {
        token: this.authService.getToken()  // use `auth`, not `query`
      },
    });

    this.socket.on('connect', () => {
      console.log('Connected:', this.socket.id);
      this.socket.emit('join_room', info);
    });

    this.socket.on('connect_error', err => {
      console.error('Socket connection error:', err);
    });
  }

  startReplacement(info: string, nodeCount, isToHubPro) {
    this.socket.emit('initiateReplacement', JSON.stringify({info: info, numberOfNodes: nodeCount, isToHubPro: isToHubPro}));
    return Observable.create((observer) => {
      this.socket.on('replacementStatus', (data) => {
        if (data) {
          observer.next(data);
        } else {
          observer.error('Unable To Reach Server');
        }
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  resumeReplacement(info: string, step, nodeCount, isToHubPro) {
    this.socket.emit('resumeReplacement', JSON.stringify({info: info + '|' + step, numberOfNodes: nodeCount, isToHubPro: isToHubPro}));
  }

  disconnect() {
    if(this.socket)
      this.socket.disconnect();
  }

}
